import { render, staticRenderFns } from "./AdminIframe.vue?vue&type=template&id=393d760a&"
import script from "./AdminIframe.vue?vue&type=script&lang=ts&"
export * from "./AdminIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports